import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const MenuItems = (props) => {
  const { parentMenu } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <>
      <li className={parentMenu === 'home' || location.pathname === '/' ? 'active' : ''}>
        <Link to="/">Anasayfa</Link>
      </li>
      <li className={parentMenu === 'about' || location.pathname === '/about-us' ? 'active' : ''}>
        <a
          href="#hakkimizda"
          onClick={(e) => scrollToSection('hakkimizda', e)}
        >
          Hakkımızda
        </a>
      </li>
      <li className={`has-dropdown ${parentMenu === 'products' || location.pathname === '/robotkol' || location.pathname === '/seyir' ? 'active' : ''}`}>
        <a
          href="#robotik-kol"
          onClick={(e) => scrollToSection('robotik-kol', e)}
        >
          Ürünler
        </a>
        <ul className="submenu">
          <li>
            <a
              href="#hakkimizda"
              onClick={(e) => scrollToSection('hakkimizda', e)}
            >
              İnsansız Su Altı Robotu
            </a>
          </li>
          <li>
            <Link to="/robotkol">
              Robot Kol
            </Link>
          </li>
          <li>
            <Link to="/seyir">
              Seyir Sistemi
            </Link>
          </li>
        </ul>
      </li>
      <li className={parentMenu === 'solutions' || location.pathname === '/solutions' ? 'active' : ''}>
        <a
          href="#cozumler"
          onClick={(e) => scrollToSection('cozumler', e)}
        >
          Çözümler
        </a>
      </li>
      <li className={location.pathname === '/iletisim' ? 'active' : ''}>
        <Link to="/iletisim">İletişim</Link>
      </li>
    </>
  );
};

export default MenuItems;
